var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNcertSummary = function SvgNcertSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A09EE7",
    d: "M32.982 2.745v34.74c0 1.517-1.213 2.746-2.71 2.746H2.71C1.212 40.231 0 39.002 0 37.485V2.745C0 1.229 1.212 0 2.709 0h27.564c1.496 0 2.708 1.229 2.708 2.745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECFA",
    d: "M34.726 4.514v34.74c0 1.518-1.213 2.747-2.71 2.747H4.454c-1.497 0-2.709-1.23-2.709-2.746V4.515c0-1.516 1.212-2.745 2.709-2.745h27.564c1.496 0 2.709 1.229 2.709 2.744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M34.727 4.508v34.741c0 1.517-1.215 2.75-2.712 2.75H4.458c-.91 0-1.72-.462-2.208-1.166.438.31.967.487 1.538.487h27.566c1.496 0 2.703-1.224 2.703-2.741V3.837c0-.586-.173-1.131-.487-1.575a2.76 2.76 0 0 1 1.157 2.246"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#52565E",
    d: "m5.51 11.515 2.143-6.431H9.39l2.143 6.431h-1.64l-.396-1.313H7.504l-.396 1.313zm3.638-2.479-.647-2.12-.648 2.12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C5F1",
    d: "M13.498 5.084h17.464v.699H13.498zM13.498 7.277h17.464v.699H13.498zM13.498 9.47h17.464v.7H13.498zM13.498 11.664h17.464v.699H13.498zM5.51 13.857h25.45v.7H5.51zM5.51 16.053h25.45v.698H5.51zM5.51 18.246h25.45v.699H5.51zM5.51 20.44h25.45v.698H5.51zM5.51 22.633h25.45v.698H5.51zM5.51 24.828h25.45v.699H5.51zM5.51 27.02h25.45v.698H5.51zM5.51 29.215h25.45v.698H5.51zM5.51 31.41h25.45v.699H5.51zM5.51 33.602h25.45v.698H5.51zM5.51 35.797h25.45v.699H5.51zM5.51 37.988h25.45v.699H5.51z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F19248",
    d: "M41.873 9.11 26.355 32.062l-3.04-2.113L38.832 6.997a.753.753 0 0 1 1.047-.198l1.798 1.25a.777.777 0 0 1 .196 1.061"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDCB6",
    d: "m23.318 29.947-.713 4.027c-.03.172.154.3.301.209l3.447-2.127z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3E3F",
    d: "m23.737 33.67-.833.515c-.145.092-.33-.037-.299-.207l.172-.974z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6772D",
    d: "M41.872 9.108 26.355 32.06l-1.533-1.065 15.943-23.58.912.632a.777.777 0 0 1 .195 1.061"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3B607",
    d: "m41.874 9.11-1.152 1.699-1.535-1.062-1.51-1.052 1.152-1.698a.76.76 0 0 1 1.047-.203l.89.619.907.636c.34.23.428.717.2 1.062"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E59900",
    d: "M41.873 9.112 40.72 10.81l-1.535-1.061 1.579-2.335.907.637a.78.78 0 0 1 .2 1.061"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "m41.043 10.332-.322.478-1.536-1.061-1.51-1.053L38 8.22l1.509 1.052z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "m41.044 10.33-.323.478-1.535-1.06.322-.478z"
  })));
};
export default SvgNcertSummary;